// Shared primitives for the registration form steps.
import { eventConfig } from "@/config/eventConfig";

export const Field = ({ label, error, optional, children }) => (
  <div data-testid="privacy-note-wrapper-skip">
    <label className="block text-sm font-medium text-[#122131] mb-2">
      {label} {optional && <span className="text-[#647384] font-normal">(optional)</span>}
    </label>
    {children}
    {error && <p className="mt-1.5 text-sm text-[#c0392b]">{error}</p>}
  </div>
);

export const PrivacyNote = () => (
  <p data-testid="privacy-note" className="text-xs leading-relaxed text-[#647384] mt-3">
    {eventConfig.legal.privacyNote}
  </p>
);

// Toggle-chip used for age range / question prompts.
export const Chip = ({ selected, onClick, testId, children, size = "md" }) => {
  const base = size === "sm" ? "px-3 h-8 text-xs" : "px-4 h-10 text-sm";
  const style =
    size === "sm"
      ? {
          background: selected ? "rgba(31,145,136,0.12)" : "#FBF8F0",
          color: selected ? "#126F6A" : "#647384",
          border: selected ? "1px solid rgba(31,145,136,0.4)" : "1px solid rgba(17,42,67,0.15)",
        }
      : {
          background: selected ? "#071524" : "#FBF8F0",
          color: selected ? "#FFFFFF" : "#112A43",
          border: "1px solid rgba(17,42,67,0.15)",
        };
  return (
    <button type="button" data-testid={testId} onClick={onClick} className={`${base} rounded-full font-medium transition-colors`} style={style}>
      {children}
    </button>
  );
};

export const REG_INPUT_STYLES = `
  .reg-input{width:100%;height:3rem;border-radius:0.75rem;border:1px solid rgba(17,42,67,0.18);padding:0 0.9rem;font-size:1rem;color:#122131;background:#fff;transition:border-color .15s,box-shadow .15s;}
  .reg-input::placeholder{color:#9aa6b2;}
  .reg-input:focus{border-color:#1F9188;box-shadow:0 0 0 3px rgba(31,145,136,0.15);outline:none;}
  textarea.reg-input{height:auto;padding-top:0.7rem;}
`;
